import store from '@/store/index';
import {ApiKeyVm} from 'modules/api-keys/classes/apiKeyVm';
import {AxiosResponse} from 'axios';
import {AppResponse} from 'modules/core/interfaces/appResponse';
import AuthorizedApiClient from 'modules/auth/models/authorizedApiClient';

export class SearchContactApi {
  public MasterAccountId: string;

  public constructor() {
    this.MasterAccountId = store.state.auth && store.state.auth.user
      ? store.state.auth.user.MasterAccountId
      : null;
  }

  public async search(phoneNumber: string): Promise<any> {
    const response: AxiosResponse<
      AppResponse<any>
      > = await AuthorizedApiClient.post('/Contact/GetContact', {
        MasterAccountId: this.MasterAccountId,
        PhoneNumber: phoneNumber,
    });
    const appResponse: AppResponse<any> = response.data;
    if (appResponse.IsSuccess) {
      const contact: any = appResponse.Result ? appResponse.Result : [];
      return contact;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }
}
